import { Column } from '@/presentation/components/table';
import { FaVideo } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { Video } from '../types/collections';

export const columnsVideos: Column<Video>[] = [
  { header: 'Título', accessor: 'title' },
  {
    header: 'Categoría',
    accessor: 'category',
    render: (value) => {
      if (!value) {
        return (
          <div className="flex justify-center items-center">
            <span className="px-3 py-1 rounded-full text-xs font-semibold bg-gray-200 text-gray-700">
              Sin categoría
            </span>
          </div>
        );
      }
      const isVideo = value === 'video';
      const isVideoPodcast = value === 'podcast' || value === 'videopodcast';
      let colorClass = '';
      if (isVideo) {
        colorClass = 'bg-blue-100 text-blue-800';
      } else if (isVideoPodcast) {
        colorClass = 'bg-pink-100 text-pink-800';
      } else {
        colorClass = 'bg-purple-100 text-purple-800';
      }
      return (
        <div className="flex justify-center items-center">
          <span
            className={`px-3 py-1 rounded-full text-xs font-semibold ${colorClass}`}
          >
            {isVideo ? 'Video' : isVideoPodcast ? 'VideoPodcast' : String(value)}
          </span>
        </div>
      );
    },
  },
  {
    header: 'Descripción',
    accessor: 'description',
    render: (value) => {
      if (value && typeof value === 'string') {
        return (
          <span className="text-sm truncate block max-w-[400px]">{value}</span>
        );
      }
      return <span className="text-sm">No hay descripción</span>;
    },
  },
  {
    header: 'Creado el',
    accessor: 'createdAt',
    render: (value) => {
      if (value && typeof value === 'object' && 'seconds' in value) {
        return (
          <span className="text-sm">
            {new Date(value.seconds! * 1000).toLocaleDateString()}
          </span>
        );
      }
      return <span className="text-sm">Desconocido</span>;
    },
  },
  {
    header: 'Vistas',
    accessor: 'views',
    render: (value) => (
      <div className="flex justify-center items-center">
        <span className="text-sm">
          {value && typeof value === 'number' ? value : 0}
        </span>
      </div>
    ),
  },
  {
    header: 'Descargas',
    accessor: 'downloads',
    render: (value) => (
      <div className="flex justify-center items-center">
        <span className="text-sm">
          {value && typeof value === 'number' ? value : 0}
        </span>
      </div>
    ),
  },
  {
    header: 'Favoritos',
    accessor: 'favorites',
    render: (value) => (
      <div className="flex justify-center items-center">
        <span className="text-sm">
          {value && typeof value === 'number' ? value : 0}
        </span>
      </div>
    ),
  },
  {
    header: 'Comentarios',
    accessor: 'comments',
    render: (value) => (
      <div className="flex justify-center items-center">
        <span className="text-sm">
          {value && typeof value === 'number' ? value : 0}
        </span>
      </div>
    ),
  },
  {
    header: 'Tags',
    accessor: 'tags',
    render: (value) => (
      <span className="text-sm">
        {value && Array.isArray(value) ? value.join(', ') : 'Sin tags'}
      </span>
    ),
  },
  {
    header: 'Video',
    accessor: 'uri',
    render: (value) =>
      value ? (
        <Link to={value.toString()} target="_blank" rel="noreferrer">
          <div className="flex justify-center items-center">
            <FaVideo className="text-red-500" size={24} />
          </div>
        </Link>
      ) : (
        <div className="flex justify-center items-center">
          <FaVideo className="text-gray-500" size={24} />
        </div>
      ),
  },
];
